<div class="main">
    <h2 translate>home.lblFileTransfersHistory</h2>
    <div class="dx-fieldset">
        <div class="dx-field">
            <div class="dx-field-label" translate>logs.lblEnvironment</div>
            <div class="dx-field-value" *ngIf="environments.length > 0 && selectedEnvironment">
                <app-environment-picker [environments]="environments" [(selectedItem)]="selectedEnvironment"
                                        (selectedItemChange)="loadDataSource()"></app-environment-picker>
            </div>
        </div>
        <br />
        <dx-data-grid #logs
                      keyExpr="id"
                      [columnAutoWidth]="true"
                      [dataSource]="dataSource"
                      [errorRowEnabled]="false"
                      [focusedRowEnabled]="true"
                      [height]="400"
                      [hoverStateEnabled]="true"
                      [paging]="pagingInfos"
                      [wordWrapEnabled]="false"
                      (onContextMenuPreparing)="onContextMenuPreparing($event)"
                      (onRowDblClick)="showDetail($event)">
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-scrolling showScrollbar="always"></dxo-scrolling>
            <dxo-search-panel [placeholder]="'_commons.search' | translate" [visible]="true" [width]="250"></dxo-search-panel>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-summary>
                <dxi-total-item column="transferDate" [displayFormat]="'logs.lblLogsCount' | translate" summaryType="count"></dxi-total-item>
            </dxo-summary>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div *dxTemplate>
                        <dx-date-range-box applyValueMode="useButtons" labelMode="hidden" width="250" [max]="maxDate" [(value)]="selectedDates" (onValueChanged)="dateChanged()"></dx-date-range-box>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button icon="refresh" (onClick)="loadDataSource()"></dx-button>
                    </div>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>

            <dxi-column dataField="transferDate" [caption]="'logs.lblDateUtc' | translate" dataType="datetime" format="MMMM d, yyyy HH:mm:ss"></dxi-column>
            <dxi-column dataField="fileTransferName" [caption]="'logs.lblTransfer' | translate"></dxi-column>
            <dxi-column dataField="logTypeEnums" [caption]="'logs.lblEvent' | translate" [calculateCellValue]="displayType"></dxi-column>
            <dxi-column dataField="sourceFileName" [caption]="'logs.lblFile' | translate"></dxi-column>
            <dxi-column dataField="sourceFileSize" [caption]="'logs.lblFileSizeKb' | translate" [calculateCellValue]="formatSourceFileSize" [alignment]="'right'"></dxi-column>
        </dx-data-grid>
    </div>
</div>

<!-- Display file transfer log popup -->
<app-file-transfer-log #fileTransferLogPopup></app-file-transfer-log>